import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { AuditChainStatus, AuditListResponse } from "@/types";

// #238 UC-3: Audit-of-record (admin-only). Liste gefiltert/paginiert + Integritäts-Check.
export interface AuditFilterInput {
  action?: string;
  actor?: string;
  target?: string;
  // #239 B5 — OCSF-Filter.
  actorType?: string;
  outcome?: string;
  limit: number;
  offset: number;
}

export function useAudit(filter: AuditFilterInput): UseQueryResult<AuditListResponse> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "audit", "list", filter],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      const qs = new URLSearchParams();
      if (filter.action) qs.set("action", filter.action);
      if (filter.actor) qs.set("actor", filter.actor);
      if (filter.target) qs.set("target", filter.target);
      if (filter.actorType) qs.set("actorType", filter.actorType);
      if (filter.outcome) qs.set("outcome", filter.outcome);
      qs.set("limit", String(filter.limit));
      qs.set("offset", String(filter.offset));
      return client.get<AuditListResponse>(`/audit?${qs.toString()}`);
    },
    enabled: !!session,
  });
}

export function useAuditVerify(): UseQueryResult<AuditChainStatus> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "audit", "verify"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<AuditChainStatus>("/audit/verify");
    },
    enabled: !!session,
  });
}
